import React from "react";
import { Box, Typography, Paper, Button } from "@mui/material";
import PropTypes from "prop-types";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import styles from "./style.module.scss";

const Card = ({
  btnText = "",
  cardTitle = "",
  btn = false,
  totalQuestions = null,
  currentSitting = null,
  assessment = false,
  diagnostic = false,
  enableDiagnostic = () => true,
  cards = [],
  goToPlacement = () => console.warn("goToPlacement not implemented"),
  fullTitle = false,
}) => {
  const splitTitle = cardTitle.split(" ");

  return (
    <Paper elevation={3} className={styles.card} sx={{ borderRadius: "16px" }}>
      <Box className={styles.contentWrap}>
        <Typography
          variant={assessment ? "subtitle1" : "h2"}
          className={`${styles.baseTitle} ${
            assessment ? styles.altCardTitle : styles.cardTitle
          } ${fullTitle ? styles.fullTitle : ""}`}
        >
          {assessment || fullTitle ? (
            cardTitle
          ) : (
            <>
              {splitTitle[0]}
              <span className={styles.text}>
                {splitTitle[1] ? ` ${splitTitle[1]}` : ""}
              </span>
            </>
          )}
        </Typography>

        {totalQuestions && (
          <Typography className={styles.totalQuestions} variant={"body1"}>
            {Number(totalQuestions) === 1
              ? `${totalQuestions} Question`
              : Number(totalQuestions) > 1
              ? `${totalQuestions} Questions`
              : ""}
          </Typography>
        )}
        {currentSitting && (
          <Typography className={styles.currentSitting} variant={"body1"}>
            {currentSitting?.isCompleted
              ? `Completed ✅`
              : !currentSitting.upTo && !totalQuestions
              ? ""
              : `${Number(currentSitting?.upTo)} / ${totalQuestions} Questions`}
          </Typography>
        )}

        {!enableDiagnostic() && diagnostic && btnText === "Start" && (
          <Typography className={styles.diagText}>
            The diagnostic test will be available after finishing all previous
            tests.
          </Typography>
        )}

        {btn && (
          <Button
            className={styles.btn}
            disabled={
              diagnostic
                ? !enableDiagnostic() || currentSitting?.isCompleted
                : false
            }
            onClick={() => goToPlacement()}
          >
            {btnText}
            <ArrowForwardIcon />
          </Button>
        )}
      </Box>
    </Paper>
  );
};

Card.propTypes = {
  btnText: PropTypes.string,
  cardTitle: PropTypes.string,
  btn: PropTypes.bool,
  assessment: PropTypes.bool,
  diagnostic: PropTypes.bool,
  enableDiagnostic: PropTypes.func,
  cards: PropTypes.array,
  goToPlacement: PropTypes.func,
  fullTitle: PropTypes.bool,
};

export default Card;
